import { useQuery } from "@tanstack/react-query";
import axios from "axios";


const useTypesValues = () => {
    const { data, isLoading, error} = useQuery({
        queryKey: ["type"],
        queryFn: () => getData(),
    });

    return {data, isLoading, error};
}

const getData = async () => {
    const response = await axios.get(`/event-types/`);
    return response.data;
}

export default useTypesValues